/* eslint-disable jsx-a11y/aria-role */
import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { DetailsSummary } from '@bingads-webui-campaign-react/recommendation-details-view';
import {
  getDetailsSummary,
  AUTO_APPLY_TYPES,
  SUPPORT_ADINSIGHT_AUTO_APPLY_TYPES,
} from '@bingads-webui-campaign/recommendation-core';

export class RecommendationsDetailsHeader extends React.PureComponent {
  static propTypes = {
    data: PropTypes.objectOf(PropTypes.any),
    scope: PropTypes.shape({
      levelAt: PropTypes.string.isRequired,
      advertiserCustomerId: PropTypes.number.isRequired,
      userId: PropTypes.number.isRequired,
      accountId: PropTypes.number.isRequired,
    }).isRequired,
    type: PropTypes.string.isRequired,
    navigateBack: PropTypes.func.isRequired,
    currency: PropTypes.string.isRequired,
    deps: PropTypes.shape({
      i18n: PropTypes.PropTypes.shape({
        getString: PropTypes.func.isRequired,
      }).isRequired,
      appConfig: PropTypes.objectOf(PropTypes.any).isRequired,
      permissions: PropTypes.object.isRequired,
      odata: PropTypes.PropTypes.shape({
        get: PropTypes.func.isRequired,
        patch: PropTypes.func.isRequired,
      }).isRequired,
      preferencesService: PropTypes.objectOf(PropTypes.any),
    }).isRequired,
    visible: PropTypes.bool.isRequired,
    isMCC: PropTypes.bool,
    overallOptimizationScoreBar: PropTypes.shape({
      Gained: PropTypes.number,
      Dismissed: PropTypes.number,
      Available: PropTypes.number,
    }),
    isOptimizationScoreOn: PropTypes.bool,
    context: PropTypes.shape({
      Source: PropTypes.string,
      Level: PropTypes.string,
      Category: PropTypes.string,
    }),
    newI18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func,
    }),
    isAutoApplyRecommendationEnabled: PropTypes.bool,
    viewSettings: PropTypes.func,
    isDismissedCategory: PropTypes.bool,
  };

  static defaultProps = {
    data: null,
    isMCC: false,
    overallOptimizationScoreBar: null,
    isOptimizationScoreOn: false,
    context: null,
    newI18n: {
      getString: _.noop,
    },
    isAutoApplyRecommendationEnabled: false,
    viewSettings: _.noop,
    isDismissedCategory: false,
  };

  render() {
    if (!this.props.visible) {
      return (null);
    }
    // get summary model from data
    const normalizedData =
      _.isUndefined(this.props.data[this.props.type]) ?
        {} : this.props.data[this.props.type];
    let showAutoApplyBanner;
    if (this.props.isAutoApplyRecommendationEnabled) {
      showAutoApplyBanner = _.contains(
        _.keys(AUTO_APPLY_TYPES).concat(SUPPORT_ADINSIGHT_AUTO_APPLY_TYPES),
        this.props.type
      )
        && !this.props.isMCC
        && normalizedData.isAutoApplyOptIn
        && new URLSearchParams(window.location.search).get('IsRSAAutoApplyEnabled') !== 'false';
    } else {
      showAutoApplyBanner = _.contains(_.keys(AUTO_APPLY_TYPES), this.props.type)
        && !this.props.isMCC
        && this.props.deps.permissions.IsRSAAutoApplyEnabled
        && normalizedData.optInStatus
        && new URLSearchParams(window.location.search).get('IsRSAAutoApplyEnabled') !== 'false';
    }

    const { summary } = getDetailsSummary(_.extend(
      {},
      normalizedData,
      {
        i18n: this.props.deps.i18n,
        newI18n: this.props.newI18n,
        currency: this.props.currency,
        scope: this.props.scope.levelAt,
        appConfig: this.props.deps.appConfig,
        permissions: this.props.deps.permissions,
        isMCC: this.props.isMCC,
        showAutoApplyBanner,
        isAutoApplyRecommendationEnabled: this.props.isAutoApplyRecommendationEnabled,
      }
    ));

    return (
      <DetailsSummary
        {...summary}
        i18n={this.props.deps.i18n}
        odata={this.props.deps.odata}
        cid={this.props.scope.advertiserCustomerId}
        uid={this.props.scope.userId}
        aid={this.props.scope.accountId}
        type={this.props.type}
        optInStatus={normalizedData.optInStatus}
        recommendationsCount={normalizedData.recommendationsCount}
        applyDate={normalizedData.applyDate}
        accounts={normalizedData.accounts}
        appConfig={this.props.deps.appConfig}
        isMCC={this.props.isMCC}
        permissions={this.props.deps.permissions}
        optimizationScore={normalizedData.optimizationScore}
        preferencesService={this.props.deps.preferencesService}
        overallOptimizationScoreBar={this.props.overallOptimizationScoreBar}
        isOptimizationScoreOn={this.props.isOptimizationScoreOn}
        context={this.props.context}
        newI18n={this.props.newI18n}
        showAutoApplyBanner={showAutoApplyBanner}
        isAutoApplyRecommendationEnabled={this.props.isAutoApplyRecommendationEnabled}
        viewSettings={this.props.viewSettings}
        isDismissedCategory={this.props.isDismissedCategory}
        isAutoApplyOptIn={normalizedData.isAutoApplyOptIn}
      />
    );
  }
}
